import { combineReducers } from 'redux';
import { RESET_STORE } from '../constants/initialization';
import app from './app';
import ui from './ui';
import domain from './domain';

const applicationReducer = combineReducers({
  app,
  ui,
  domain,
});

const savedResetStoreAfterOmit = {
  app: {
    persistStorage: {},
  },
};

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = savedResetStoreAfterOmit;
  }

  return applicationReducer(state, action);
};

export default rootReducer;
